import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "group p-4 bg-primary rounded-lg shadow-md ring-1 ring-primary/20 transition-all duration-200" }
const _hoisted_2 = { class: "flex flex-col gap-3" }
const _hoisted_3 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_4 = { class: "text-lg font-medium text-white" }
const _hoisted_5 = { class: "text-white/90" }
const _hoisted_6 = { class: "flex flex-wrap gap-2" }
const _hoisted_7 = {
  key: 0,
  class: "px-2.5 py-1 text-xs font-medium rounded-md shadow-sm transition-colors duration-200 bg-gray-400 text-gray-700"
}
const _hoisted_8 = { class: "flex flex-col gap-2 text-white/90" }
const _hoisted_9 = { class: "flex items-center gap-2" }
const _hoisted_10 = { class: "font-medium text-white" }
const _hoisted_11 = { class: "flex items-center gap-2" }
const _hoisted_12 = { class: "font-medium text-white" }


import { FishTransfer } from '@/types/v2';
import { OperationInfo } from "@/types/v2/task/animal-transfer/operation.types";

interface TransferListItemProps {
    transfer: FishTransfer
    transferInfo?: OperationInfo;
    index: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TransferListItem',
  props: {
    transfer: {},
    transferInfo: {},
    index: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.transferInfo?.prefix[_ctx.index]) + " Tank: " + _toDisplayString(_ctx.transfer.tank.label) + " ", 1),
          _createElementVNode("span", _hoisted_5, "(" + _toDisplayString(_ctx.transfer.tank.room) + ")", 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transfer.animalGroup.tags, (tag) => {
            return (_openBlock(), _createElementBlock("span", {
              key: tag.key,
              class: "px-2.5 py-1 text-xs font-medium rounded-md shadow-sm transition-colors duration-200",
              style: _normalizeStyle({
                            backgroundColor: tag.backgroundColor,
                            color: tag.textColor
                        })
            }, _toDisplayString(tag.title), 5))
          }), 128)),
          (!_ctx.transfer.animalGroup.tags || _ctx.transfer.animalGroup.tags.length === 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, " Unmarked "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("p", _hoisted_9, [
          _createTextVNode(" Planned amount to " + _toDisplayString(_ctx.transferInfo?.action.lower[_ctx.index]) + ": ", 1),
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.transferInfo?.amount), 1)
        ]),
        _createElementVNode("p", _hoisted_11, [
          _createTextVNode(" Actual amount " + _toDisplayString(_ctx.transferInfo?.action.past[_ctx.index]) + ": ", 1),
          _createElementVNode("span", _hoisted_12, _toDisplayString(Math.abs(_ctx.transfer.actualTransfer)), 1)
        ])
      ])
    ])
  ]))
}
}

})